<form [formGroup]="formGroup">
  <mat-form-field>
    <mat-label>Billing address</mat-label>
    <input
      matInput
      #searchInput
      formControlName="billingaddress"
      placeholder="Enter billing address"
      (input)="onInputAddress($event)"
    />
    <div matSuffix tabindex="-1" class="p-r-m">
      <mat-icon>
        <i class="healent-form-input-icon-24-2 primary-color"></i>
      </mat-icon>
    </div>
    <mat-error style="font-size: 12px"
      >Valid billing address required</mat-error
    >
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Zip code</mat-label>
    <input
      matInput
      formControlName="billingzip"
      placeholder="Enter Zip code"
      (input)="onInputZipCode($event)"
      type="text"
      inputmode="numeric"
      pattern="\d*"
    />
    <div matSuffix tabindex="-1" class="p-r-m">
      <mat-icon>
        <i class="healent-form-input-icon-24-1 primary-color"></i>
      </mat-icon>
    </div>
    <mat-error style="font-size: 12px">Valid zip code required</mat-error>
  </mat-form-field>
</form>
